import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import styles from "./EntityInfo.scss";
import { defineMessages, injectIntl, FormattedMessage } from "react-intl";
import classnames from "classnames";

const msgs = defineMessages({
  book: {
    id: "room_selection.notification.book",
    description: "book button",
    defaultMessage: "BOOK",
  },
});

function EntityInfo({ text, onClickButton, ...props }) {
  const createMarkup = () => {
    return { __html: text };
  };
  return (
    <div {...props} className={classnames("wbkv9-EntityInfo", styles.entityInfoContainer)}>
      <div className={styles.carouselContainer}>
        <div className={styles.descriptionContainer} dangerouslySetInnerHTML={createMarkup()}></div>
      </div>
      <div className={classnames("wbkv9-EntityInfo-bookButtonContainer", "bookButtonContainer")}>
        <button className={styles.entityInfoButton} onClick={onClickButton}>
          <FormattedMessage {...msgs.book} />
        </button>
      </div>
    </div>
  );
}

EntityInfo.propTypes = {
  items: PropTypes.array.isRequired,
};

export default injectIntl(pure(EntityInfo));
